import { AttachmentOptions } from "@/constants/attachment";
import { AxiosResponse } from "axios";
import { pushFileDownload } from "./dataLayer";

export const downloadFile = (response: AxiosResponse<Blob>, defaultFileName: string) => {
  const contentDisposition = response.headers["content-disposition"] as string | undefined;
  const filename = contentDisposition?.split("filename=")[1]?.replace(/"/g, "") ?? defaultFileName;

  const url = URL.createObjectURL(response.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);

  const fileType = filename.split(".").pop() ?? "";
  const fileLocation = `${response.config.baseURL ?? ""}${response.config.url ?? ""}`;
  pushFileDownload(filename, fileType, "Other", fileLocation);
};

export const creteUploadFormData = (
  blob: Blob,
  uuid: string,
  userId: string | number,
  fileName: string,
  fileTypeCode: string,
  isContractRequest: boolean,
  attachmentOptions?: AttachmentOptions
) => {
  const formData = new FormData();
  const isContract = !isContractRequest;

  if (isContract) {
    formData.append("progress", "0");
    formData.append("status", "uploading");
  }
  formData.append("group_id", `${attachmentOptions?.groupId ?? 351}`);
  formData.append("biometric", `${attachmentOptions?.biometric ?? false}`);
  formData.append("file_type", attachmentOptions?.fileType ?? "ATTACHMENT");
  formData.append("file_type_code", fileTypeCode);
  formData.append("internal", `${attachmentOptions?.internal ?? true}`);
  formData.append("paper_request", `${attachmentOptions?.paperRequest ?? false}`);
  formData.append("human_name", attachmentOptions?.humanName ?? fileName);
  formData.append("qqpartindex", "0");
  formData.append("qqpartbyteoffset", "0");
  formData.append("qqfilename", fileName);
  formData.append("file_name", fileName);
  formData.append("qqtotalfilesize", `${blob.size}`);
  formData.append("qqchunksize", `${blob.size}`);
  formData.append("qqtotalparts", "1");
  formData.append("qquuid", uuid);
  formData.append("qqfile", blob, fileName);
  formData.append("uploaded_by_id", `${userId}`);

  return formData;
};
